// extracted by mini-css-extract-plugin
export default {"container":"Dice_container__UoBz2","activeDice":"Dice_activeDice__wZnlZ","diceImg":"Dice_diceImg__HMhoc"};